export interface IDonorConnectGroup {
     Nkdo: boolean,
     Nkf: boolean,
     Nkr: boolean
}


